// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__QsocY","title":"Header_title__e_Wvz","side":"Header_side__3_q2f"};